import React from "react"
import { getQueries } from "../functions"
import { useLocation, Link, useHistory } from "react-router-dom"
import { LoginBgArray, actionObjLocalReducer, InputFieldState, SignUpType, InputFieldObj } from "../const"
import { selectRandomFromArray, sanitizeHTML, userFieldExistance, signUp } from "../functions"
import { validateEmail, validatePassword, validateName } from "../validations"
import SelectField from "./stateless/SelectField"
import InputField from "./stateless/InputField"
import BackgroundWithImage from "./BackgroundWithImage"
import { useGlobalContext } from "../context"

function localReducer(state: InputFieldState, action: actionObjLocalReducer) {
    // console.log(state, action)
    const newState = { ...state }
    switch (action.type) {
        case "set-error":
            newState[action.payload[0]].err = action.payload[1]
            newState[action.payload[0]].val = ""
            return newState
        case "remove-error":
            newState[action.payload].err = ""
            return newState
        case "set-value":
            newState[action.payload[0]].err = ""
            newState[action.payload[0]].val = sanitizeHTML(action.payload[1])
            return newState

        case "set-validationFn":
            newState[action.payload[0]].validationFn = action.payload[1]
            return newState

        default:
            return state
    }
}

//>>>>>>>>>> Select field needed to choose the version of language

const SignUp = () => {
    const location = useLocation()
    const { method, order_locator } = getQueries(location.search)
    const history = useHistory()
    const { globalState, dispatch, log, t } = useGlobalContext()
    const [error, setError] = React.useState("")
    const [localState, localDispatch] = React.useReducer(localReducer, {
        password: { val: "", err: "", required: true, validationFn: validatePassword },
        email: { val: "", err: "", required: true, validationFn: validateEmail },
        firstName: { val: "", err: "", required: true, validationFn: validateName },
        lastName: { val: "", err: "", required: true, validationFn: validateName },
        hashedLink: { val: order_locator, err: "", required: true, validationFn: validateName },
        lang: { val: "", err: "", required: true, validationFn: validateName },
        method: { val: method, err: "", required: true, validationFn: validateName },
    })

    const submitHandler = async (e: React.FormEvent) => {
        e.preventDefault()
        console.log(localState)

        const hasError = Object.entries(localState)
            .map(([key, value]) => {
                if (value.required && value.err) return key
                else if (value.required && !value.val) {
                    localDispatch({ type: "set-error", payload: [key, "Cannot be empty!"] })
                    return key
                }
                return ""
            })
            .filter((item) => Object.keys(localState).includes(item))

        if (hasError.length) return

        const data = Object.entries(localState).reduce((acc: any, curr) => {
            acc[curr[0]] = curr[1].val
            return acc
        }, {} as SignUpType)

        await signUp(data).then((res) => {
            console.log("-------------", res)
            if (res.error) return setError(t(res.error))
            else if (res.authorized && res.approved) {
                dispatch({ type: "set-user", payload: res })
                return history.push(`/${res.lang}/user/dashboard`)
            }
        })
    }

    return (
        <div className="login">
            <BackgroundWithImage bgUrl={selectRandomFromArray(LoginBgArray)}>
                <div className="content">
                    <form onSubmit={submitHandler}>
                        <h1>Sign-up Form</h1>
                        {globalState.error && <p>{t(globalState.error)}</p>}
                        <InputField field="firstName" label="First Name" state={localState} dispatch={localDispatch} />
                        <InputField field="lastName" label="Last Name" state={localState} dispatch={localDispatch} />
                        <InputField field="email" label="Email" state={localState} dispatch={localDispatch} />
                        <InputField field="password" label="Password" type="password" state={localState} dispatch={localDispatch} />
                        <SelectField
                            field="lang"
                            label="Choose Course Version"
                            state={localState}
                            dispatch={localDispatch}
                            array={[
                                { code: "", name: "--" },
                                { code: "en", name: "English Instruction" },
                                { code: "fa", name: "Farsi Instruction" },
                            ]}
                        />

                        <div className="button-area">
                            {error && <p>{error}</p>}
                            <button type="submit">Sign Up!</button>
                            <br />
                        </div>
                    </form>
                </div>
            </BackgroundWithImage>
        </div>
    )
}

export default SignUp

//localhost:3000/member/en/signup?method=paypal&order_locator=12ed9381284093bb08e2ab2b403bab400c363600e7b34cbb3a47409ec5771f4babde8b46f5036f312f39dec507f2f404